// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/@radix-ui/colors/black-alpha.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/@radix-ui/colors/mauve.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!../../../node_modules/@radix-ui/colors/violet.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* reset */
@keyframes slideUpAndFade {
  from {
    opacity: 0;
    transform: translateY(2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideRightAndFade {
  from {
    opacity: 0;
    transform: translateX(-2px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
@keyframes slideDownAndFade {
  from {
    opacity: 0;
    transform: translateY(-2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes slideLeftAndFade {
  from {
    opacity: 0;
    transform: translateX(2px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}
.PopoverContent {
  z-index: 9999;
  border-radius: 4px;
  width: 400px;
  min-height: 300px;
  max-height: 600px;
  background-color: #f5f5f5;
  box-shadow: hsla(206, 22%, 7%, 0.35) 0px 10px 38px -10px, hsla(206, 22%, 7%, 0.2) 0px 10px 20px -15px;
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
}
.PopoverContent:focus {
  box-shadow: hsla(206, 22%, 7%, 0.35) 0px 10px 38px -10px, hsla(206, 22%, 7%, 0.2) 0px 10px 20px -15px, 0 0 0 2px #00889b;
}
.PopoverContent .header-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
}
.PopoverContent .notification-content {
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  height: 450px;
  padding-bottom: 25px;
}
@media (max-height: 600px) {
  .PopoverContent .notification-content {
    height: 400px;
  }
}
@media (max-height: 550px) {
  .PopoverContent .notification-content {
    height: 350px;
  }
}
.PopoverContent .notification-content .notification-item {
  text-decoration: none;
  color: #000;
}
.PopoverContent .notification-content .notification-item:hover {
  color: #00889b;
}

.PopoverContent[data-state=open][data-side=top] {
  animation-name: slideDownAndFade;
}

.PopoverContent[data-state=open][data-side=right] {
  animation-name: slideLeftAndFade;
}

.PopoverContent[data-state=open][data-side=bottom] {
  animation-name: slideUpAndFade;
}

.PopoverContent[data-state=open][data-side=left] {
  animation-name: slideRightAndFade;
}

.PopoverArrow {
  fill: white;
}

.PopoverClose {
  font-family: inherit;
  border-radius: 100%;
  height: 25px;
  width: 25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #00889b;
  position: absolute;
  top: 5px;
  right: 5px;
}
.PopoverClose:hover {
  background-color: var(--violet-4);
}
.PopoverClose:focus {
  box-shadow: 0 0 0 2px #00889b;
}

.IconButton {
  font-family: inherit;
  border-radius: 100%;
  height: 35px;
  width: 35px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--violet-11);
  background-color: white;
  box-shadow: 0 2px 10px var(--black-a7);
}
.IconButton:hover {
  background-color: var(--violet-3);
}
.IconButton:focus {
  box-shadow: 0 0 0 2px black;
}

.Fieldset {
  display: flex;
  gap: 20px;
  align-items: center;
}

.Label {
  font-size: 13px;
  color: var(--violet-11);
  width: 75px;
}

.Input {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 13px;
  line-height: 1;
  color: #00889b;
  box-shadow: 0 0 0 1px var(--violet-7);
  height: 25px;
}
.Input:focus {
  box-shadow: 0 0 0 2px var(--violet-8);
}

.Text {
  margin: 0;
  color: var(--mauve-12);
  font-size: 15px;
  line-height: 19px;
  font-weight: 500;
}

.notification-icon {
  color: #00889b;
  height: 35px;
  width: 25px;
  position: relative;
}
.notification-icon button {
  all: unset;
}

.popover-trigger-btn {
  all: unset;
}

.notification-header-text {
  font-size: 24px;
  font-weight: bold;
}

.notification-mark-read {
  all: unset;
}

.notification-item.non-clickable {
  pointer-events: none;
  cursor: default;
}

.notification-item {
  transition: background-color 0.2s;
}

.notification-item:hover {
  background-color: #f0f0f0;
}

.notification-item.non-clickable:hover {
  background-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/components/common/NotificationPopover.scss","webpack://./src/styles/colors.scss"],"names":[],"mappings":"AAYA,UAAA;AACA;EACE;IACE,UAAA;IACA,0BAAA;EARF;EAUA;IACE,UAAA;IACA,wBAAA;EARF;AACF;AAUA;EACE;IACE,UAAA;IACA,2BAAA;EARF;EAUA;IACE,UAAA;IACA,wBAAA;EARF;AACF;AAUA;EACE;IACE,UAAA;IACA,2BAAA;EARF;EAUA;IACE,UAAA;IACA,wBAAA;EARF;AACF;AAUA;EACE;IACE,UAAA;IACA,0BAAA;EARF;EAUA;IACE,UAAA;IACA,wBAAA;EARF;AACF;AAWA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;EACA,qGAAA;EAEA,yBAAA;EACA,wDAAA;EACA,+BAAA;AAVF;AAWE;EACE,wHAAA;AATJ;AAYE;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,aAAA;AAVJ;AAYE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;AAVJ;AAYI;EAPF;IAQI,aAAA;EATJ;AACF;AAWI;EAXF;IAYI,aAAA;EARJ;AACF;AAUI;EACE,qBAAA;EACA,WAAA;AARN;AAUM;EACE,cCvEQ;AD+DhB;;AAaA;EACE,gCAAA;AAVF;;AAYA;EACE,gCAAA;AATF;;AAWA;EACE,8BAAA;AARF;;AAUA;EACE,iCAAA;AAPF;;AASA;EACE,WAAA;AANF;;AAQA;EACE,oBApHc;EAqHd,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,cChHY;EDiHZ,kBAAA;EACA,QAAA;EACA,UAAA;AALF;AAME;EACE,iCA9HiB;AA0HrB;AAME;EACE,6BAAA;AAJJ;;AAOA;EACE,oBAvIc;EAwId,mBAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,uBAhJQ;EAiJR,uBA9ImB;EA+InB,sCAAA;AAJF;AAKE;EACE,iCA/IiB;AA4IrB;AAKE;EACE,2BAAA;AAHJ;;AAMA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAHF;;AAKA;EACE,eAAA;EACA,uBAjKQ;EAkKR,WAAA;AAFF;;AAIA;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,cCjKY;EDkKZ,qCAAA;EACA,YAAA;AADF;AAEE;EACE,qCAAA;AAAJ;;AAGA;EACE,SAAA;EACA,sBAtLQ;EAuLR,eAAA;EACA,iBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,cCjLY;EDkLZ,YAAA;EACA,WAAA;EACA,kBAAA;AAAF;AACE;EACE,UAAA;AACJ;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,eAAA;EACA,iBAAA;AAAF;;AAGA;EACE,UAAA;AAAF;;AAGA;EACE,oBAAA;EACA,eAAA;AAAF;;AAGA;EACE,iCAAA;AAAF;;AAGA;EACE,yBAAA;AAAF;;AAGA;EACE,6BAAA;AAAF","sourcesContent":["$color_1: var(--violet-11);\n$color_2: var(--mauve-12);\n$font-family_1: inherit;\n$background-color_1: white;\n$background-color_2: var(--violet-4);\n$background-color_3: var(--violet-3);\n@import \"../../styles/colors\";\n@import \"../../styles/sizes\";\n\n@import \"@radix-ui/colors/black-alpha.css\";\n@import \"@radix-ui/colors/mauve.css\";\n@import \"@radix-ui/colors/violet.css\";\n/* reset */\n@keyframes slideUpAndFade {\n  from {\n    opacity: 0;\n    transform: translateY(2px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n@keyframes slideRightAndFade {\n  from {\n    opacity: 0;\n    transform: translateX(-2px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n@keyframes slideDownAndFade {\n  from {\n    opacity: 0;\n    transform: translateY(-2px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n@keyframes slideLeftAndFade {\n  from {\n    opacity: 0;\n    transform: translateX(2px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n.PopoverContent {\n  z-index: 9999;\n  border-radius: 4px;\n  width: 400px;\n  min-height: 300px;\n  max-height: 600px;\n  background-color: #f5f5f5;\n  box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px,\n    hsl(206 22% 7% / 20%) 0px 10px 20px -15px;\n  animation-duration: 400ms;\n  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);\n  will-change: transform, opacity;\n  &:focus {\n    box-shadow: hsl(206 22% 7% / 35%) 0px 10px 38px -10px,\n      hsl(206 22% 7% / 20%) 0px 10px 20px -15px, 0 0 0 2px $btn-primary;\n  }\n  .header-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 20px;\n  }\n  .notification-content {\n    display: flex;\n    flex-direction: column;\n    overflow-y: scroll;\n    height: 450px;\n    padding-bottom: 25px;\n\n    @media (max-height: 600px) {\n      height: 400px;\n    }\n\n    @media (max-height: 550px) {\n      height: 350px;\n    }\n\n    .notification-item {\n      text-decoration: none;\n      color: #000;\n\n      &:hover {\n        color: $primary-color;\n      }\n    }\n  }\n}\n.PopoverContent[data-state=\"open\"][data-side=\"top\"] {\n  animation-name: slideDownAndFade;\n}\n.PopoverContent[data-state=\"open\"][data-side=\"right\"] {\n  animation-name: slideLeftAndFade;\n}\n.PopoverContent[data-state=\"open\"][data-side=\"bottom\"] {\n  animation-name: slideUpAndFade;\n}\n.PopoverContent[data-state=\"open\"][data-side=\"left\"] {\n  animation-name: slideRightAndFade;\n}\n.PopoverArrow {\n  fill: white;\n}\n.PopoverClose {\n  font-family: $font-family_1;\n  border-radius: 100%;\n  height: 25px;\n  width: 25px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: $btn-primary;\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  &:hover {\n    background-color: $background-color_2;\n  }\n  &:focus {\n    box-shadow: 0 0 0 2px $btn-primary;\n  }\n}\n.IconButton {\n  font-family: $font-family_1;\n  border-radius: 100%;\n  height: 35px;\n  width: 35px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: $color_1;\n  background-color: $background-color_1;\n  box-shadow: 0 2px 10px var(--black-a7);\n  &:hover {\n    background-color: $background-color_3;\n  }\n  &:focus {\n    box-shadow: 0 0 0 2px black;\n  }\n}\n.Fieldset {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n}\n.Label {\n  font-size: 13px;\n  color: $color_1;\n  width: 75px;\n}\n.Input {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  border-radius: 4px;\n  padding: 0 10px;\n  font-size: 13px;\n  line-height: 1;\n  color: $btn-primary;\n  box-shadow: 0 0 0 1px var(--violet-7);\n  height: 25px;\n  &:focus {\n    box-shadow: 0 0 0 2px var(--violet-8);\n  }\n}\n.Text {\n  margin: 0;\n  color: $color_2;\n  font-size: 15px;\n  line-height: 19px;\n  font-weight: 500;\n}\n\n.notification-icon {\n  color: $btn-primary;\n  height: 35px;\n  width: 25px;\n  position: relative;\n  button {\n    all: unset;\n  }\n}\n\n.popover-trigger-btn {\n  all: unset;\n}\n\n.notification-header-text {\n  font-size: 24px;\n  font-weight: bold;\n}\n\n.notification-mark-read {\n  all: unset;\n}\n\n.notification-item.non-clickable {\n  pointer-events: none;\n  cursor: default;\n}\n\n.notification-item {\n  transition: background-color 0.2s;\n}\n\n.notification-item:hover {\n  background-color: #f0f0f0;\n}\n\n.notification-item.non-clickable:hover {\n  background-color: transparent;\n}\n","$site-text: #00171f;\n$safe-list: #8e8e93;\n$trans-white: rgba(255, 255, 255, 0.5);\n$trans-grey: rgba(211, 211, 211, 0.5);\n$disabled-link: rgba(142, 142, 147, 0.15);\n$white: #ffffff;\n$page-background: #f5fbff;\n\n$link: #007ea7;\n$font-awesome-icon-color: #85a3ad;\n\n// Buttons\n$btn-color-white: #ffffff;\n$btn-primary: #00889b;\n$secondary: #9db6be;\n$favorite-star: #f9a825;\n\n// Forms\n$form-control-border: #e7edef;\n$form-color: #85a3ad;\n$form-error: #ef6360;\n\n//text color\n$text-normal: #414b4f;\n\n//primary\n$primary-color: #00889b;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
